import { render, staticRenderFns } from "./CardSeplag.vue?vue&type=template&id=25a5a786&scoped=true&"
import script from "./CardSeplag.vue?vue&type=script&lang=js&"
export * from "./CardSeplag.vue?vue&type=script&lang=js&"
import style0 from "./CardSeplag.vue?vue&type=style&index=0&id=25a5a786&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a5a786",
  null
  
)

export default component.exports